import React from 'react'
import { Alert } from '@mui/material'

import useTranslations from '../../../../../i18n/useTranslations'
import IconPlan from '../../../../../assets/icons/IconPlan'

import RadioGroup from './RadioGroup'

const List = ({ deliveryPoints, selectAddress, selectedAddress }) => {
  const t = useTranslations()

  if (deliveryPoints.length === 0) {
    return (
      <Alert icon={<IconPlan />} type="info" extraClass="is-infoNotification">
        <p>{t('delivery-point:list:no-results')}</p>
      </Alert>
    )
  }

  const sortedDeliveryPoints = deliveryPoints.sort((a, b) => {
    return a.name.localeCompare(b.name)
  })

  return (
    <>
      <RadioGroup
        extraClass="is-deliveryPoint"
        name="deliveryPoint"
        selected={selectedAddress}
        options={sortedDeliveryPoints.map(deliveryPoint => ({
          onClick: _option => selectAddress(deliveryPoint),
          name: deliveryPoint.name,
          label: deliveryPoint.name,
          value: deliveryPoint.address,
          fullAddress: deliveryPoint.address,
          distance: null,
          extraInfo: {
            schedule: deliveryPoint.schedule,
            phone: deliveryPoint.phoneNumber,
          },
        }))}
      />
    </>
  )
}

export default List
